import React, { useEffect, useState } from "react";
import { UserJobsTable } from "../../component/common/customTable/UserJobsTable";
import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsersJobsAsync } from "../../services/UserJobsServices";
import { asyncStatus } from "../../utils/asyncStatus";
import { themeOrange, themeBlue } from "../../utils/colorTheme";
import { IoAdd, IoSearch } from "react-icons/io5";

const DashboardUserJobs = () => {
  const { get_all_user_jobs_status, get_all_user_jobs_data } = useSelector(
    (state) => state.userJobsSlice
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    dispatch(getAllUsersJobsAsync());
  }, []);

  if (get_all_user_jobs_status === asyncStatus.LOADING) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ height: "50vh" }}>
        <CircularProgress size={30} sx={{ color: themeOrange }} />
      </Stack>
    );
  }

  return (
    <Stack sx={{ bgcolor: "#F8F9FA", minHeight: "100vh" }}>
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 3, py: 2.5 }}
      >
        <Stack>
          <Typography sx={{ fontSize: "24px", fontWeight: 700, color: themeBlue }}>
            Orders
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#999", mt: 0.3 }}>
            View and manage all job orders
          </Typography>
        </Stack>
        <Box
          onClick={() => navigate("/orders/create-job")}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            background: "linear-gradient(135deg, #F15A24 0%, #C53F10 100%)",
            color: "#fff",
            px: 2.5,
            py: 1.2,
            borderRadius: "10px",
            cursor: "pointer",
            transition: "all 0.2s",
            "&:hover": { transform: "translateY(-1px)", boxShadow: "0 4px 12px rgba(241,90,36,0.35)" },
          }}
        >
          <IoAdd size={18} />
          <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Create Job</Typography>
        </Box>
      </Stack>

      <Container sx={{ maxWidth: { xl: "xl", lg: "lg", md: "md", sm: "sm", xs: "xs" } }}>
        {/* Search + Filters */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          gap={2}
          mb={2}
        >
          <TextField
            size="small"
            placeholder="Search by service, customer, email, or order ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IoSearch color="#999" />
                </InputAdornment>
              ),
            }}
            sx={{
              width: { xs: "100%", sm: "400px" },
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                bgcolor: "#fff",
                "&.Mui-focused fieldset": { borderColor: themeOrange },
                "&:hover fieldset": { borderColor: themeOrange },
              },
            }}
          />
          <Stack direction="row" alignItems="center" gap={2}>
            <FormControl size="small">
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                displayEmpty
                sx={{
                  minWidth: 160,
                  borderRadius: "10px",
                  bgcolor: "#fff",
                  fontSize: "13px",
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: themeOrange },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: themeOrange },
                }}
              >
                <MenuItem value="">All Statuses</MenuItem>
                <MenuItem value="In-Queue">In Queue</MenuItem>
                <MenuItem value="Assigned">Assigned</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                <MenuItem value="Cancelled">Cancelled</MenuItem>
                <MenuItem value="Refunded">Refunded</MenuItem>
              </Select>
            </FormControl>
            <Typography sx={{ fontSize: "13px", color: "#999", whiteSpace: "nowrap" }}>
              {get_all_user_jobs_data?.length || 0} orders
            </Typography>
          </Stack>
        </Stack>

        <Stack
          sx={{
            bgcolor: "#fff",
            borderRadius: "14px",
            boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
            overflow: "hidden",
            mb: 4,
          }}
        >
          <UserJobsTable searchQuery={searchQuery} statusFilter={statusFilter} />
        </Stack>
      </Container>
    </Stack>
  );
};

export default DashboardUserJobs;
